// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4424": "8c2b85f4","8561": "f9cad78a","8990": "7d69c8cd",}[chunkId] + ".css"
}